import { IPetAlertModel, PetAlertModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class PetAlertService {
  private static baseUrl: string = '/api/petalert';

  static tags = {
    updatePetAlert: 'updatePetAlert',
    deletePetAlert: 'deletePetAlert',
  };

  /**
   * Updates PetAlert
   * @param data PetAlert Model to update
   * @param options Service Method Options
   * @returns PetAlert Model
   */
  static upsertPetAlert = (
    data: IPetAlertModel,
    options?: ServiceMethodOptions,
  ): Promise<PetAlertModel> => {
    return trackPromise(
      new Promise<IPetAlertModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IPetAlertModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Pet Alert updated', options);
            resolve(new PetAlertModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Pet Alert.', options);
            reject(err);
          });
      }),
      this.tags.updatePetAlert,
    );
  };

  static deletePetAlert = (
    petAlertId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${petAlertId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Pet Alert has been deleted', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Pet Alert.', options);
            reject(err);
          });
      }),
      this.tags.deletePetAlert,
    );
  };
}
